<!-- <div class="bg-ingreso-pro">
    <div class="numerolocker"><span>{{casillero}}</span></div>
</div> -->
<!-- <app-escan-rut></app-escan-rut> -->
<app-seleccion-empresa></app-seleccion-empresa>
<!-- <button class="btn btnl btnv" (click)="volver()">
    Volver
  </button> -->

